module.exports = __webpack_public_path__ + "static/assets/cb361639dae9d85d56793fc11965ae67.svg";